import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useResearchContext } from "@/context-state/ResearchContext.jsx"
import * as API from '@/services/api.js'
import { toast } from 'sonner'
import { handleError } from '@/services/errorHandler.js'
import { MainLoader } from "@/components/loader/MainLoader"
import { daysBetweenTimestamps, daysSinceTimestamp } from "@/utils/date"

export const BoardDataProvider = ({ children }) => {

    const { getBoardToExternalAdsMapsFromState, updateBoardToExternalAdsMapsState, getBoardFromState, updateManyExternalAdsState } = useResearchContext()
    const { boardId } = useParams()

    const adsForThisBoard = getBoardToExternalAdsMapsFromState(boardId)
    const board = getBoardFromState(boardId)

    const fetchBoardData = async () => {
        try {

            if (!board.externalAds?.length) {
                updateBoardToExternalAdsMapsState(boardId, [])
                return
            }

            const { data } = await API.getManyExternalAdsById(board.externalAds)
            // filter the data by 'collectionId', make sure there are no duplications
            const unique = Object.values(
                data.reduce((acc, item) => {
                    if (!acc[item.collectionId]) {
                        acc[item.collectionId] = item
                        const amountOfDays = item.isActive ? daysSinceTimestamp(item.startDate) : daysBetweenTimestamps(item.startDate, item.endDate)
                        item.amountOfDays = amountOfDays <= 0 ? 1 : amountOfDays
                    }
                    return acc
                }, {})
            )

            updateBoardToExternalAdsMapsState(boardId, unique.map(ad => ad._id))
            updateManyExternalAdsState(unique)
        } catch (e) {
            toast.error(e.message)
            console.log(e)
            handleError(e)
        }
    }

    useEffect(() => {
        if (!adsForThisBoard) {
            fetchBoardData()
        }
    }, [boardId])

    return adsForThisBoard ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
}